import { X } from "lucide-react";
import { useState } from "react";
import { SlackEditor } from "./SlackEditor";

export function LinkPopover({
  selectedText,
  onInsert,
  onClose,
}: {
  selectedText: string;
  onInsert: (label: string, url: string) => void;
  onClose: () => void;
}) {
  const [label, setLabel] = useState(selectedText);
  const [url, setUrl] = useState("https://");
  return (
    <form
      className="popover link-popover"
      onSubmit={(event) => {
        event.preventDefault();
        if (label && /^https?:\/\//.test(url)) onInsert(label, url);
      }}
    >
      <div className="popover-head">
        <strong>{selectedText ? "Link selected text" : "Add link"}</strong>
        <button type="button" onClick={onClose}>
          <X size={16} />
        </button>
      </div>
      <label htmlFor="link-display-text">
        Text
        <SlackEditor
          id="link-display-text"
          value={label}
          onChange={setLabel}
          mode="emoji"
          maxLength={300}
          ariaLabel="Link text"
          placeholder="Event page"
        />
      </label>
      <label>
        Link
        <input type="url" value={url} onChange={(event) => setUrl(event.target.value)} inputMode="url" />
      </label>
      <button className="small-primary" type="submit">
        Add
      </button>
    </form>
  );
}
